import { ElementType, LinkText, SpecType, SubType } from '../../utils/RioUtils/interfaces';
import { sendRioEvent } from '../../utils/RioUtils/rioHelper';
export var onCtaButtonClick = function onCtaButtonClick(_ref) {
  var event = _ref.event,
    isReview = _ref.isReview,
    namespace = _ref.namespace,
    onClick = _ref.onClick,
    onRioEventFired = _ref.onRioEventFired;
  if (typeof onClick === 'function') {
    onClick(event);
    sendRioEvent({
      info: isReview ? LinkText.REVIEW_ORDER : LinkText.JOIN_NOW,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: onRioEventFired,
      namespace: namespace
    });
  }
};
export var onSecondaryCtaButtonClick = function onSecondaryCtaButtonClick(event, onClick) {
  if (typeof onClick === 'function') {
    onClick(event);
  }
};
export var getCTAButtonText = function getCTAButtonText(ctaContent, isReview, isUpgrade) {
  var cta = ctaContent.cta,
    reviewButtonText = ctaContent.reviewButtonText,
    upgradeButtonText = ctaContent.upgradeButtonText;
  var buttonText = cta;
  if (isReview && reviewButtonText) {
    buttonText = reviewButtonText;
  }
  if (!isReview && isUpgrade && upgradeButtonText) {
    buttonText = upgradeButtonText;
  }
  return buttonText;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/CTA/helpers.js
// module id = 1386
// module chunks = 11